/**
 * @generated SignedSource<<0f4153d6b6b017e3b20e165a058385bf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_JiraIssueFieldLinkRelationshipReadviewFull_LinkRelationshipTypeReadView$data = {
  readonly issueLink: {
    readonly relationName: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "ui_JiraIssueFieldLinkRelationshipReadviewFull_LinkRelationshipTypeReadView";
};
export type ui_JiraIssueFieldLinkRelationshipReadviewFull_LinkRelationshipTypeReadView$key = {
  readonly " $data"?: ui_JiraIssueFieldLinkRelationshipReadviewFull_LinkRelationshipTypeReadView$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_JiraIssueFieldLinkRelationshipReadviewFull_LinkRelationshipTypeReadView">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ui_JiraIssueFieldLinkRelationshipReadviewFull_LinkRelationshipTypeReadView",
  "selections": [
    {
      "concreteType": "JiraIssueLink",
      "kind": "LinkedField",
      "name": "issueLink",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "relationName"
        }
      ]
    }
  ],
  "type": "JiraIssueLinkRelationshipTypeField"
};

(node as any).hash = "361dcf400dbdcd55049456b0ff5b544a";

export default node;
